var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "13px",
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "91614285-0AB4-40C6-A761-4C34705B0098") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Relationship-Details--Add/Edit-Contact",
    transform: "translate(-933.000000, -710.000000)",
    fill: "#AF1B1B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(933.420243, 710.250000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.61538462,4.61538462 C4.36015385,4.61538462 4.15384615,4.82169231 4.15384615,5.07692308 L4.15384615,8.76923077 C4.15384615,9.02446154 4.36015385,9.23076923 4.61538462,9.23076923 C4.87061538,9.23076923 5.07692308,9.02446154 5.07692308,8.76923077 L5.07692308,5.07692308 C5.07692308,4.82169231 4.87061538,4.61538462 4.61538462,4.61538462 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46153846,4.61538462 C6.20630769,4.61538462 6,4.82169231 6,5.07692308 L6,8.76923077 C6,9.02446154 6.20630769,9.23076923 6.46153846,9.23076923 C6.71676923,9.23076923 6.92307692,9.02446154 6.92307692,8.76923077 L6.92307692,5.07692308 C6.92307692,4.82169231 6.71676923,4.61538462 6.46153846,4.61538462 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92307692,0 L4.15384615,0 C3.64476923,0 3.23076923,0.414 3.23076923,0.923076923 L3.23076923,1.84615385 L1.84615385,1.84615385 L0.461538462,1.84615385 C0.206307692,1.84615385 0,2.05246154 0,2.30769231 C0,2.56292308 0.206307692,2.76923077 0.461538462,2.76923077 L1.38461538,2.76923077 L1.38461538,10.6153846 C1.38461538,11.3787692 2.00584615,12 2.76923077,12 L8.30769231,12 C9.07107692,12 9.69230769,11.3787692 9.69230769,10.6153846 L9.69230769,2.76923077 L10.6153846,2.76923077 C10.8706154,2.76923077 11.0769231,2.56292308 11.0769231,2.30769231 C11.0769231,2.05246154 10.8706154,1.84615385 10.6153846,1.84615385 L9.23076923,1.84615385 L7.84615385,1.84615385 L7.84615385,0.923076923 C7.84615385,0.414 7.43215385,0 6.92307692,0 Z M8.76923077,10.6153846 C8.76923077,10.8701538 8.56246154,11.0769231 8.30769231,11.0769231 L2.76923077,11.0769231 C2.51446154,11.0769231 2.30769231,10.8701538 2.30769231,10.6153846 L2.30769231,2.76923077 L8.76923077,2.76923077 L8.76923077,10.6153846 Z M4.15384615,1.84615385 L4.15384615,0.923076923 L6.92307692,0.923076923 L6.92307692,1.84615385 L4.15384615,1.84615385 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2d750eedad03589ab86637122f38dd49.svg";
export { ForwardRef as ReactComponent };